import cx from 'classnames';
import { Link } from 'gatsby-link';
import React from 'react';

import { Image, ScrollToTop, TracsisLogoGhost } from '../../../index';
import { LinkedIn, X } from '../../Icon/index';
import {
	INavigationItem,
	INavigationLink,
	ISocialLink,
} from '../Layout/Layout';
import * as styles from './Footer.module.css';

const Footer = ({
	logo,
	social,
	navigation,
	subNavigation,
	isGroup = false,
	iso,
}: {
	logo?: React.ReactNode;
	social?: ISocialLink[];
	navigation?: INavigationItem[];
	subNavigation?: INavigationLink[];
	isGroup?: boolean;
	iso?: Array<object>;
}) => {
	return (
		<footer className={styles.footer}>
			<ScrollToTop />

			<div className={styles.layout}>
				<div className={styles.navigationRow}>
					<div className={styles.marketing}>
						{logo && <div className={styles.logo}>{logo}</div>}

						{social && (
							<ul className={styles.social}>
								{social.map(({ platform, to }, key: number) => (
									<li key={key}>
										<a href={to} target="_blank" className={styles.platform}>
											<div className={styles.socialIcon}>
												{platform === 'X' ? <X /> : <LinkedIn />}
											</div>
											{platform}
										</a>
									</li>
								))}
							</ul>
						)}
					</div>

					<div className={styles.actions}>
						<div className={styles.navigations}>
							{navigation && (
								<nav>
									<ul className={styles.list}>
										{navigation.map(({ to, label, subMenus }, key: number) =>
											subMenus ? null : (
												<li key={key}>
													<Link to={to} className={styles.link}>
														{label}
													</Link>
												</li>
											)
										)}
									</ul>
								</nav>
							)}

							{subNavigation && (
								<nav>
									<ul className={cx(styles.list, styles.small)}>
										{subNavigation.map(({ to, label }, key: number) => (
											<li key={key}>
												<Link to={to} className={cx(styles.link, styles.light)}>
													{label}
												</Link>
											</li>
										))}
									</ul>
								</nav>
							)}
						</div>
					</div>

					{iso && (
						<div className={styles.certifications}>
							<div className="header-row">Certification</div>
							<nav>
								<ul>
									{iso.map((item: any, key: number) => {
										return (
											<li key={key}>
												<a href={item.link} target="_blank">
													<Image
														image={'/iso/Approachable_UKAS_no-border.gif'}
														fit="contain"
														alt={item.text}
														className={styles.isoLogo}
													/>
													<span className={styles.link}>{item.text}</span>
												</a>
											</li>
										);
									})}
								</ul>
							</nav>
						</div>
					)}
				</div>

				<div className={styles.metadata}>
					{!isGroup && (
						<div className={styles.groupLogo}>
							<TracsisLogoGhost />
						</div>
					)}

					<p className={styles.copyright}>
						Website by <a href="https://majordigital.com">MAJOR</a>. | Copyright
						&copy; {new Date().getFullYear()} Tracsis plc.
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
